import { render } from "./dispatch-invitations.vue?vue&type=template&id=34c15d05&scoped=true"
import script from "./dispatch-invitations.vue?vue&type=script&lang=js"
export * from "./dispatch-invitations.vue?vue&type=script&lang=js"

import "./dispatch-invitations.vue?vue&type=style&index=0&id=34c15d05&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c15d05"]])

export default __exports__